import initialState from './state.js'

export default {
  RESET_WANT_SELL_MODULE(state) {
    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key]
    })
  },
  SET_OPPORTUNITIES(state, payload) {
    state.opportunities = payload
  },
  SET_OPPORTUNITIES_KEY(state, { key, payload }) {
    state.opportunities[key] = payload
  },
  SET_SELECTED_ANALYSIS_PRODUCTS(state, payload) {
    state.selectedAnalysisProducts = payload
  },
  SET_SELECTED_BOOST_PRODUCTS(state, payload) {
    state.selectedBoostProducts = payload
  },
}
